import {AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {
    ExpectedMoveColumnsToShow,
    ExpectedMoveDaysToExpiration,
    ExpectedMoveRangeModel, ExpectedMoveSettings,
    ExpectedMoveWhereToShow
} from "./expected-move.service";
import {ApplicationSettingsService} from "../app-settings/application-settings.service";
import {DetectMethodChanges, DetectSetterChanges, isVoid} from "../utils";

@Component({
    selector: 'expected-move-settings-component',
    templateUrl: 'expected-move-settings.component.html',
    styleUrls: ['expected-move-settings.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ExpectedMoveSettingsComponent implements OnInit, AfterViewInit {

    constructor(
        private readonly _changeDetector: ChangeDetectorRef,
        private readonly _appSettings: ApplicationSettingsService) {
    }

    get showHmColumns() : boolean {
        return !isVoid(this.whereToShow) && this.whereToShow.indexOf('Hedge Matrix') !== -1;
    }

    private _enabled: boolean;
    get enabled(): boolean {
        return this._enabled || false;
    }

    @DetectSetterChanges()
    set enabled(value: boolean) {
        this._enabled = value;
    }

    rangeModelList = [
        'ATM Straddle',
        'Custom Percentage',
    ];

    rangeModel: ExpectedMoveRangeModel;

    rangeModelCustomPercent: number;
    range1Enabled = true;
    range2Enabled = false;
    range2CustomPercent: number;
    showAtmStraddleValue = false;

    daysToExpirationList: ExpectedMoveDaysToExpiration[] = [
        '0',
        '1',
        '0 & 1',
        'All'
    ];

    daysToExpiration: ExpectedMoveDaysToExpiration;

    whereToShowList: ExpectedMoveWhereToShow[] = [
        'OPG',
        'Hedge Matrix',
        'OPG & Hedge Matrix'
    ];

    whereToShow: ExpectedMoveWhereToShow;

    hmColumnsToShowList: ExpectedMoveColumnsToShow[] = [
        'Expiration',
        'PnL',
        'Expiration & PnL'
    ];

    hmColumnsToShow: ExpectedMoveColumnsToShow;

    @DetectMethodChanges()
    ngOnInit(): void {
    }

    @DetectMethodChanges()
    ngAfterViewInit() {
        this.fillSettings();
    }


    getSettings(): ExpectedMoveSettings {
        return {
            rangeModel: this.rangeModel,
            rangeModelCustomPercent: this.rangeModelCustomPercent,
            range1Enabled: this.range1Enabled,
            range2Enabled: this.range2Enabled,
            range2CustomPercent: this.range2CustomPercent,
            showAtmStraddleValue: this.showAtmStraddleValue,
            enabled: this.enabled,
            daysToExpiration: this.daysToExpiration,
            whereToShow: this.whereToShow,
            hmColumnsToShow: this.hmColumnsToShow
        };
    }

    @DetectMethodChanges()
    onChange() {

    }

    reset() {
        this.enabled = false;
        this.rangeModel = null;
        this.whereToShow = null;
        this.daysToExpiration = null;
        this.rangeModelCustomPercent = null;
        this.range1Enabled = true;
        this.range2Enabled = false;
        this.range2CustomPercent = null;
        this.showAtmStraddleValue = false;
        this.hmColumnsToShow = null;
    }

    private fillSettings() {
        const expectedMoveSettings = this._appSettings.expectedMoveSettings;

        this.enabled = expectedMoveSettings?.enabled;
        this.rangeModel = expectedMoveSettings?.rangeModel;
        this.daysToExpiration = expectedMoveSettings?.daysToExpiration;
        this.whereToShow = expectedMoveSettings?.whereToShow;
        this.rangeModelCustomPercent = expectedMoveSettings?.rangeModelCustomPercent;
        this.range1Enabled = expectedMoveSettings?.range1Enabled !== false;
        this.range2Enabled = expectedMoveSettings?.range2Enabled === true;
        this.range2CustomPercent = expectedMoveSettings?.range2CustomPercent;
        this.showAtmStraddleValue = expectedMoveSettings?.showAtmStraddleValue === true;
        this.hmColumnsToShow = expectedMoveSettings?.hmColumnsToShow;
    }

    @DetectMethodChanges()
    init() {
        this.fillSettings();
    }
}
